/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AdminWorkstreamImporterRowPreview } from './AdminWorkstreamImporterRowPreview';

export type AdminWorkstreamImporterPreviewResponse = {
    doc_url: string;
    doc_title: string;
    doc_revision: string;
    fiscal_year: number;
    fiscal_half: AdminWorkstreamImporterPreviewResponse.fiscal_half;
    timeframe: string;
    narrative_root_workstream_id: number;
    valid_row_count: number;
    invalid_row_count: number;
    rows: Array<AdminWorkstreamImporterRowPreview>;
};

export namespace AdminWorkstreamImporterPreviewResponse {

    export enum fiscal_half {
        H1 = 'H1',
        H2 = 'H2',
    }


}

